var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegramSquare = function SvgTelegramSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H5a5 5 0 0 0-5 5v22a5 5 0 0 0 5 5h22a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5Z",
    fill: "#08C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 15.708c4.295-1.87 7.159-3.105 8.592-3.7 4.091-1.702 4.942-1.998 5.496-2.008.122-.002.394.028.57.171.15.121.19.285.21.4.02.114.044.375.025.58-.222 2.33-1.181 7.983-1.67 10.592-.206 1.104-.613 1.474-1.006 1.51-.856.079-1.505-.565-2.334-1.108-1.297-.85-2.03-1.38-3.288-2.209-1.455-.959-.512-1.485.317-2.346.217-.226 3.987-3.655 4.06-3.966.01-.039.018-.184-.069-.26-.086-.077-.213-.05-.305-.03-.13.03-2.201 1.4-6.214 4.108-.588.404-1.12.6-1.598.59-.526-.011-1.538-.297-2.29-.542-.923-.3-1.656-.458-1.592-.968.033-.265.398-.536 1.096-.814Z",
    fill: "#fff"
  })));
};
export default SvgTelegramSquare;